import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决NavigationDuplicated:报错
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

import Layout from '@views/layout'


// 不区分用户角色
export const constantRouterMap = [
  { path: '/demo', component: () => import('@views/demo') },
  { path: '/login', component: () => import('@views/login') },
  { path: '/register', component: () => import('@views/login/register') },
  {
    path: '/',
    name: 'index',
    component: Layout,
    meta: { title: '首页' },
    redirect: '/home',
    children: [
      // 首页
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home'),
        meta: { title: '首页', rank: 1, keepAlive: true }
      },
      {
        path: '/video',
        name: 'video',
        component: () => import('@/views/video'),
        meta: {
          title: '视频资源',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '视频资源',
            disabled: true
          }]
        },
        beforeEnter(to, from, next) {
          window.scrollTo(0, 0)
          // const isFirstNavigation = !from.name
          // if (isFirstNavigation) {
          //   // 手动将页面滚动到顶部
          //   window.scrollTo(0, 0)
          // }
          next()
        }
      },
      {
        path: '/video/detail',
        name: 'videoDetail',
        component: () => import('@/views/video/detail'),
        meta: {
          title: '视频详情',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '视频资源',
            href: '/video'
          }, {
            text: '列表',
            disabled: true
          }]
        }
      },
      {
        path: '/search',
        name: 'search',
        component: () => import('@/views/home/search'),
        meta: {
          title: '搜索',
          // breadList: [
          //   {
          //     text: '首页',
          //     href: '/home'
          //   }, {
          //     text: '搜索',
          //     disabled: true
          //   }],
        }
      },
      {
        path: '/museum',
        name: 'museum',
        redirect: '/museum/open-time',
        component: () => import('@/views/museum'),
        children: [{
          path: '/museum/open-time',
          name: 'openTime',
          component: () => import('@/views/museum/open-time'),
          meta: {
            breadList: [
              {
                text: '首页',
                href: '/home'
              }, {
                text: '导览',
                disabled: true
              }],
          }
        }, {
          path: '/museum/ticket',
          name: 'ticket',
          component: () => import('@/views/museum/ticket'),
          meta: {
            breadList: [
              {
                text: '首页',
                href: '/home'
              }, {
                text: '导览',
                disabled: true
              }],
          }
        }, {
          path: '/museum/traffic',
          name: 'traffic',
          component: () => import('@/views/museum/traffic'),
          meta: {
            breadList: [
              {
                text: '首页',
                href: '/home'
              }, {
                text: '导览',
                disabled: true
              }],
          }
        }, {
          path: '/museum/notice',
          name: 'notice',
          component: () => import('@/views/museum/notice'),
          meta: {
            breadList: [
              {
                text: '首页',
                href: '/home'
              }, {
                text: '导览',
                disabled: true
              }],
          }
        }, {
          path: '/museum/guide',
          name: 'guide',
          component: () => import('@/views/museum/guide'),
          meta: {
            breadList: [
              {
                text: '首页',
                href: '/home'
              }, {
                text: '导览',
                disabled: true
              }],
          }
        }, {
          path: '/museum/explain',
          name: 'explain',
          component: () => import('@/views/museum/explain'),
          meta: {
            breadList: [
              {
                text: '首页',
                href: '/home'
              }, {
                text: '导览',
                disabled: true
              }],
          }
        }, {
          path: '/museum/voice',
          name: 'voice',
          component: () => import('@/views/museum/voice'),
          meta: {
            breadList: [
              {
                text: '首页',
                href: '/home'
              }, {
                text: '导览',
                disabled: true
              }],
          }
        }, {
          path: '/museum/dinning-bar',
          name: 'dinningBar',
          component: () => import('@/views/museum/dining-bar'),
          meta: {
            breadList: [
              {
                text: '首页',
                href: '/home'
              }, {
                text: '导览',
                disabled: true
              }],
          }
        }],
        meta: {
          title: '导览',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '导览',
            disabled: true
          }],
          hideBread: true
        }
      },
      // {
      //   path: '/museum/micro-site',
      //   name: 'museumMicroSite',
      //   component: () => import('@/views/museum/micro-site'),
      //   meta: {
      //     title: '博物馆微网站',
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '博物馆导览',
      //       href: '/museum'
      //     }, {
      //       text: '博物馆微网站',
      //       disabled: true
      //     }],
      //   }
      // },
      {
        path: '/exhibition',
        name: 'exhibition',
        component: () => import('@/views/exhibition'),
        meta: {
          title: '展览',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '展览',
            disabled: true
          }],
          rank: 1,
          keepAlive: true
        }
      },
      {
        path: '/education/detail',
        name: 'educationDetail',
        component: () => import('@/views/education/detail'),
        meta: {
          title: '教育',
          breadStyleType: '2',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '社教活动',
            href: '/education'
          }, {
            text: '详情',
            disabled: true
          }],
          hasLine: true,
          keepAlive: false,
          rank: 2,
          keepAlive: false
        }
      },
      {
        path: '/volunteer/detail',
        name: 'volunteerDetail',
        component: () => import('@/views/education/volunteer-detail'),
        meta: {
          title: '志愿者风采详情',
        }
      },
      {
        path: '/demeanor/detail',
        name: 'demeanorDetail',
        component: () => import('@/views/education/demeanor-detail'),
        meta: {
          title: '志愿者风采详情',
          breadStyleType: '2',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '辽博志愿者',
            href: '/education?type=3'
          }, {
            text: '志愿者风采',
            disabled: true
          }],
          hasLine: true,  // 是否有上边线
        }
      },
      {
        path: '/exhibition/detail',
        name: 'ExhibitionDetail',
        component: () => import('@/views/exhibition/detail'),
        meta: {
          title: '展览',
          breadStyleType: '1',
          breadList: [
            {
              text: '首页',
              href: '/home'
            }, {
              text: '展览',
              href: '/exhibition'
            }, {
              text: '展览详情',
              disabled: true
            }],
          useStore: true,  // 采用状态中的面包屑数据
          hasLine: true,  // 是否有上边线
          rank: 2,
          keepAlive: false
        }
      },
      // {
      //   path: '/exhibition/curation',
      //   name: 'exhibitionCuration',
      //   component: () => import('@/views/exhibition/curation'),
      //   meta: {
      //     title: '观众策展',
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '观众策展',
      //       disabled: true
      //     }],
      //   }
      // },
      // {
      //   path: '/exhibition/curation/start',
      //   name: 'exhibitionCurationStart',
      //   component: () => import('@/views/exhibition/curation-start'),
      //   meta: {
      //     title: '我要策展',
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '观众策展',
      //       href: '/exhibition/curation'
      //     }, {
      //       text: '观众策展',
      //       disabled: true
      //     }],
      //   }
      // },

      {
        path: '/identify',
        name: 'identify',
        component: () => import('@/views/identify'),
        meta: {
          title: '民间文物鉴定',
          rank: 1,
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '民间文物鉴定',
            disabled: true
          }],
        }
      },
      {
        path: '/notice',
        name: 'notice',
        component: () => import('@/views/home/notice'),
        meta: {
          title: '通知公告',
          rank: 1,
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '通知公告',
            disabled: true
          }],
        }
      },
      {
        path: '/notice/detail',
        name: 'noticedetail',
        component: () => import('@/views/home/notice-detail'),
        meta: {
          title: '通知公告详情',
          breadStyleType: '1',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '通知公告',
            href: '/notice'
          }, {
            text: '详情',
            disabled: true
          }],
          hasLine: true,
        }
      },
      {
        path: '/collect',
        name: 'collect',
        component: () => import('@/views/collect'),
        meta: {
          title: '馆藏精品',
          rank: 1,
          // breadStyleType: '3',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '藏品',
            disabled: true
          }],
        }
      },
      {
        path: '/collect/list',
        name: 'collectList',
        component: () => import('@/views/collect/list'),
        meta: {
          title: '3D藏品',
          // breadStyleType: '3',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '藏品',
            disabled: true
          }],
          rank: 1,
          keepAlive: true
        }
      },
      {
        path: '/collect/digital-culture',
        name: 'collectDigitalCulture',
        component: () => import('@/views/collect/digital-culture'),
        meta: {
          title: '数字文物库',
          rank: 1,
          // breadStyleType: '3',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '藏品',
            disabled: true
          }],
          rank: 1,
          keepAlive: true
        }
      },
      // {
      //   path: '/collect/material',
      //   name: 'collectMaterial',
      //   component: () => import('@/views/collect/material'),
      //   meta: {
      //     title: '文物素材库',
      //     rank: 1,
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '藏品',
      //       disabled: true
      //     }],
      //   }
      // },
      {
        path: '/collect/material-detail',
        name: 'collectMaterialDetail',
        component: () => import('@/views/collect/material-detail'),
        meta: {
          title: '素材详情',
          breadStyleType: '2',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '文物素材库',
            href: '/collect/material'
          }, {
            text: '详情',
            disabled: true
          }],
          hasLine: true,
          rank: 2,
          keepAlive: false,
        }
      },
      // {
      //   path: '/collect/listWaterfall',
      //   name: 'collectList',
      //   component: () => import('@/views/collect/list-waterfall'),
      //   meta: {
      //     title: '数字文物库',
      //     rank: 1,
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '热门藏品',
      //       href: '/collect'
      //     }, {
      //       text: '数字文物库',
      //       disabled: true
      //     }],
      //   }
      // },
      {
        path: '/collect/detail',
        name: 'collectDetail',
        component: () => import('@/views/collect/detail'),
        meta: {
          title: '藏品详情',
          breadStyleType: '2',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '藏品',
            href: '/collect'
          }, {
            text: '详情',
            disabled: true
          }],
          useStore: true,
          rank: 2,
          keepAlive: false
        }
      },
      // {
      //   path: '/collect/topic',
      //   name: 'collectTopic',
      //   component: () => import('@/views/collect/topic'),
      //   meta: {
      //     title: '藏品专题',
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '藏品专题',
      //       disabled: true
      //     }],
      //   }
      // },
      // {
      //   path: '/collect/topic/detail',
      //   name: 'collectTopicDetail',
      //   component: () => import('@/views/collect/topic-detail'),
      //   meta: {
      //     title: '藏品专题详情',
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '藏品专题',
      //       href: '/collect/topic'
      //     }, {
      //       text: '专题详情',
      //       disabled: true
      //     }],
      //   }
      // },
      {
        path: '/collect/search-photo',
        name: 'collectSearchPhoto',
        component: () => import('@/views/collect/search-photo'),
        meta: {
          title: '智能鉴宝',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '智能鉴宝',
            disabled: true
          }],
        }
      },
      {
        path: '/research',
        name: 'research',
        component: () => import('@/views/research'),
        meta: {
          title: '研究',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '学术',
            disabled: true
          }],
          rank: 1,
          keepAlive: true
        }
      },
      {
        path: '/research/detail',
        name: 'researchDetail',
        component: () => import('@/views/research/detail'),
        meta: {
          title: '研究',
          breadStyleType: '1',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '学术',
            href: '/research'
          }, {
            text: '详情',
            disabled: true
          }],
          useStore: true,  // 采用状态中的面包屑数据
          hasLine: true,  // 是否有上边线
          rank: 2,
          keepAlive: false,
        }
      },
      {
        path: '/education',
        name: 'education',
        component: () => import('@/views/education'),
        meta: {
          title: '教育资源',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '教育',
            disabled: true
          }],
          rank: 1,
          keepAlive: true
        }
      },
      {
        path: '/education/activity',
        name: 'educationActivity',
        component: () => import('@/views/education/activity'),
        meta: {
          title: '社教活动',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '社教活动',
            disabled: true
          }],
        }
      }, {
        path: '/education/activity-detail',
        name: 'educationActivityDetail',
        component: () => import('@/views/education/activity-detail'),
        meta: {
          title: '社教活动',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '社教活动',
            href: '/education/activity'
          }, {
            text: '活动详情',
            disabled: true
          }],
        }
      },
      {
        path: '/education/intro/detail',
        name: 'introDetail',
        component: () => import('@/views/education/intro-detail.vue'),
        meta: {
          title: '资源者详情',
          breadStyleType: '1',
          useStore: true,  // 采用状态中的面包屑数据
          hasLine: true,  // 是否有上边线
        }
      },
      {
        path: '/education/high-quality',
        name: 'educationHighQuality',
        component: () => import('@/views/education/high-quality'),
        meta: {
          title: '十佳社教活动',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '十佳社教活动',
            disabled: true
          }],
        }
      },
      {
        path: '/creative',
        name: 'creative',
        component: () => import('@/views/creative'),
        meta: {
          title: '文创',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '文创',
            disabled: true
          }],
          rank: 1,
          keepAlive: true,
        }
      },
      {
        path: '/creative/detail',
        name: 'creativeDetail',
        component: () => import('@/views/creative/detail'),
        meta: {
          title: '文创详情',
          breadStyleType: '2',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '文创产品',
            href: '/creative'
          }, {
            text: '详情',
            disabled: true
          }],
          hasLine: true,
          rank: 2,
          keepAlive: false,
        }
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about'),
        meta: {
          title: '关于',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '关于',
            disabled: true
          }],
          rank: 1,
          keepAlive: true
        }
      },
      {
        path: '/about/detail',
        name: 'aboutDetail',
        component: () => import('@/views/about/detail'),
        meta: {
          title: '关于详情',
          breadStyleType: '1',
          breadList: [{
            text: '首页',
            href: '/home'
          }, {
            text: '资讯',
            href: '/about?pageType=2'
          }, {
            text: '详情',
            disabled: true
          }],
          useStore: true,  // 采用状态中的面包屑数据
          hasLine: true,
          rank: 2,
          keepAlive: false
        }
      },


      {
        path: '/dynamic',
        name: 'dynamic',
        component: () => import('@/views/dynamic'),
        meta: { title: '行业动态', rank: 1 }
      },
      // {
      //   path: '/alliance',
      //   name: 'alliance',
      //   component: () => import('@/views/alliance'),
      //   meta: {
      //     title: '博物馆联盟',
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '博物馆联盟',
      //       disabled: true
      //     }],
      //   }
      // },
      // {
      //   path: '/alliance/detail',
      //   name: 'alliance/detail',
      //   component: () => import('@/views/alliance/detail'),
      //   meta: {
      //     title: '联盟详情',
      //     breadList: [],
      //     useStore: true  // 采用状态中的面包屑数据
      //   }
      // },
      // {
      //   path: '/enterprise',
      //   name: 'enterprise',
      //   component: () => import('@/views/enterprise'),
      //   meta: {
      //     title: '企业展会',
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '企业展会',
      //       disabled: true
      //     }],
      //   }
      // },
      // {
      //   path: '/enterprise/detail',
      //   name: 'enterpriseDetail',
      //   component: () => import('@/views/enterprise/detail'),
      //   meta: {
      //     title: '企业展会详情',
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '企业展会',
      //       href: '/enterprise'
      //     }, {
      //       text: '企业详情',
      //       disabled: true
      //     }],
      //   }
      // },
      // {
      //   path: '/enterprise/detail-pro',
      //   name: 'enterpriseDetailPro',
      //   component: () => import('@/views/enterprise/detail-pro'),
      //   meta: {
      //     title: '企业展会详情',
      //     breadList: [],
      //     useStore: true  // 采用状态中的面包屑数据
      //   }
      // },
      // {
      //   path: '/appoint',
      //   name: 'appoint',
      //   component: () => import('@/views/appoint'),
      //   meta: { title: '参观预约', rank: 1 }
      // },
      // {
      //   path: '/revolution',
      //   name: 'revolution',
      //   component: () => import('@/views/revolution'),
      //   meta: {
      //     title: '革命文物',
      //     breadList: [
      //       {
      //         text: '首页',
      //         href: '/home'
      //       }, {
      //         text: '革命文物',
      //         disabled: true
      //       }],
      //   }
      // },
      // {
      //   path: '/revolution/movable-detail',
      //   name: 'revolutionMovableDetail',
      //   component: () => import('@/views/revolution/movable-detail'),
      //   meta: {
      //     title: '可移动文物详情',
      //     breadList: [
      //       {
      //         text: '首页',
      //         href: '/home'
      //       }, {
      //         text: '革命文物',
      //         href: '/revolution'
      //       }, {
      //         text: '可移动文物详情',
      //         disabled: true
      //       }],
      //   }
      // },
      // {
      //   path: '/revolution/unmovable-detail',
      //   name: 'revolutionUnmovableDetail',
      //   component: () => import('@/views/revolution/unmovable-detail'),
      //   meta: {
      //     title: '不可移动文物详情',
      //     breadList: [
      //       {
      //         text: '首页',
      //         href: '/home'
      //       }, {
      //         text: '革命文物',
      //         href: '/revolution'
      //       }, {
      //         text: '不可移动文物详情',
      //         disabled: true
      //       }],
      //   }
      // },
      // {
      //   path: '/person',
      //   name: 'person',
      //   component: () => import('@/views/person'),
      //   meta: {
      //     title: '个人中心',
      //     breadList: [{
      //       text: '首页',
      //       href: '/home'
      //     }, {
      //       text: '个人中心',
      //       disabled: true
      //     }],
      //   }
      // },
    ]
  }
]

// 区分用户角色
export const asyncRouterMap = [
  // {
  //   path: '/',
  //   name: 'index',
  //   component: Layout,
  //   meta: { title: '首页' },
  //   redirect: '/home',
  //   children: [
  //     // 首页
  //     {
  //       path: '/home',
  //       name: 'home',
  //       component: () => import('@/views/home'),
  //       meta: { title: '首页', menuLevel: 1, rank: 1 }
  //     }
  //   ]
  // }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
